var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 d-flex flex-row justify-content-end" },
    [
      _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-danger",
            attrs: { disabled: _vm.isLoading, type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [_vm._v("Abbrechen "), _c("i", { staticClass: "fas fa-times" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-success",
            attrs: { disabled: _vm.isLoading, type: "submit" }
          },
          [
            _vm._v("Speichern "),
            !_vm.isLoading ? _c("i", { staticClass: "fas fa-plus" }) : _vm._e(),
            _vm.isLoading
              ? _c("i", { staticClass: "fas fa-spinner fa-spin" })
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }